import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { forkJoin, map, Observable } from 'rxjs';

import { UsersService } from './users.service';
import { UserDetailDto, UserGetDTO } from './users.model';
import { ClientGetDTO } from '../clients/client.model';
import { ClientService } from '../clients/clients.service';
import { ApiResponseModel } from '../../core/api-response.model';
import { RouteCacheService } from '../../shared/services/route-cache.service';

@Injectable({ providedIn: 'root' })
export class UsersResolver implements Resolve<any> {
  usersService = inject(UsersService);
  clientSvc = inject(ClientService);
  routeCache = inject(RouteCacheService);

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<
    | ApiResponseModel<UserGetDTO>
    | UserDetailDto
    | { clients: ApiResponseModel<ClientGetDTO> }
    | { clients: ApiResponseModel<ClientGetDTO>; user: UserDetailDto }
  > {
    const id = route.paramMap.get('id');
    if (route.url.some((segment) => segment.path === 'add')) {
      return forkJoin({
        clients: this.clientSvc.get(undefined, { page: 1, limit: 15 }),
      });
    }
    if (id) {
      if (route.url.some((segment) => segment.path === 'edit')) {
        return forkJoin({
          clients: this.clientSvc.get(undefined, { page: 1, limit: 15 }),
          user: this.usersService.getUserById(id),
        });
      }
      return this.usersService.getUserById(id);
    }

    const contextRoute = this.routeCache.getContextRoute(route);
    const gridState = contextRoute?.data?.gridUserState;
    const filters = gridState?.filters ?? {};

    return this.usersService
      .get(undefined, {
        page:
          gridState?.paginator?.pageIndex != null
            ? gridState.paginator.pageIndex + 1
            : 1,
        limit: gridState?.paginator?.pageSize ?? 15,
        ...(filters.name ? { name: filters.name } : {}),
        ...(filters.roleId ? { roleId: filters.roleId } : {}),
      })
      .pipe(
        map((response) => ({
          ...response,
          data: response.data.map((item) => ({
            ...item,
          })),
        })),
      );
  }
}
